import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AjaxSpinner } from '../components/AjaxSpinner';
import { useAppSelector, useAppDispatch } from '../hooks';
import { useNavigate, useLocation, Outlet, ScrollRestoration } from 'react-router-dom';
import { jumpTo } from '../reducers/app';
export const App = () => {
    const dispatch = useAppDispatch();
    const appJumpTo = useAppSelector(state => state.app.jumpTo);
    const navigate = useNavigate();
    const location = useLocation();
    React.useEffect(() => {
        if (appJumpTo) {
            if (location.pathname != appJumpTo) {
                navigate(appJumpTo);
            }
            dispatch(jumpTo(null));
        }
    }, [appJumpTo, location]);
    return (_jsxs(React.Fragment, { children: [_jsx(ScrollRestoration, {}), _jsx(AjaxSpinner, {}), _jsx(Outlet, {})] }));
};
